import { DateTime } from "luxon"

export const AppointmentClaimModel = function () {
    this.claimType = 1
    this.carRegistrationNo = null // เลขทะเบียน
    this.currentGeolocation = null
    this.placeInfo = null

    this.driverName = null
    this.driverContactNumber = null
    this.appointmentDate = null
    this.appointmentTime = null
    this.location = null
}

AppointmentClaimModel.prototype.setClaimType = function (type) {
    this.claimType = type
    return this
}

AppointmentClaimModel.prototype.setCarRegistrationNo = function (no) {
    this.carRegistrationNo = no
    return this
}

/**
 * 
 * @param {*} pos 
 * @returns 
 */
AppointmentClaimModel.prototype.setGeolocation = function (pos) {
    this.currentGeolocation = pos // lat, lng
    return this
}

AppointmentClaimModel.prototype.setPlaceInfo = function(info){
    this.placeInfo = info
    return this
}

AppointmentClaimModel.prototype.getParams = function () {
    // console.log(this.appointmentDate, this.appointmentTime)
    let dtString = DateTime.fromJSDate(this.appointmentDate).startOf("day").plus({
        hours: this.appointmentTime.hours,
        minutes: this.appointmentTime.minutes,
        seconds: 0
    }).toFormat("dd/MM/yyyy HH:mm:ss")

    let json = {
        claim_type: this.claimType,
        assured_driver_name: this.driverName,
        assured_driver_mobile_no: this.driverContactNumber,
        occurrence_lat: this.currentGeolocation.lat,
        occurrence_lon: this.currentGeolocation.lng,
        occurrence_place: this.placeInfo,
        appointment_datetime: dtString,
        appiontment_place: this.location,
        car_registration_no: this.carRegistrationNo
    }

    return json
}